module.exports = __webpack_public_path__ + "img/send-jet.ade83d5a.svg";